import React from 'react';
import WardrobeSummaryPopupContent from './WardrobeSummaryPopupContent';
import PopUp from './PopUp';
import { useHistory } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

const WardrobeSummaryPopUp = ({ setOpenDoorsState, setHighlightedWardrobe }) => {
  const history = useHistory();

  const buttonsList = [
    {
      text: 'Konfiguruj',
      action: () => {
        reactLocalStorage.setObject(
          'copyWardrobe',
          reactLocalStorage.getObject('wardrobesConfigs'),
        );
        history.push('/wardrobe-body-configuration');
      },
      color: 'white',
    },
  ];

  return (
    <PopUp title="Podsumowanie" popupName="summary-wardrobe-popup" buttons={buttonsList}>
      <WardrobeSummaryPopupContent
        setOpenDoorsState={setOpenDoorsState}
        setHighlightedWardrobe={setHighlightedWardrobe}
      />
    </PopUp>
  );
};

export default WardrobeSummaryPopUp;
